const STORAGE_KEY_PREFIX = 'rfx'
/**
 * Service for storing data in localStorage {@link https://developer.mozilla.org/ru/docs/Web/API/Window/localStorage}
 */
export default class StorageService {
  remove (key) {
    StorageService.getStorage().removeItem(StorageService.getStorageKey(key))

    return this
  }

  get (key, parse = false) {
    const item = StorageService.getStorage().getItem(StorageService.getStorageKey(key))

    return parse ? JSON.parse(item) : item
  }

  set (key, item) {
    StorageService.getStorage().setItem(StorageService.getStorageKey(key), typeof item === 'object' ? JSON.stringify(item) : item)
  }

  static getStorage () {
    return localStorage
  }

  static getStorageKey (key) {
    return `${STORAGE_KEY_PREFIX}.${key}`
  }
}
